/** Replaces user-facing "prize" wording with "rent drop" for legal compliance. */
export const sanitizeRentDropTerminology = (text: string): string =>
  text
    .replace(/\bPrizes\b/g, 'Rent Drops')
    .replace(/\bprizes\b/g, 'rent drops')
    .replace(/\bPrize\b/g, 'Rent Drop')
    .replace(/\bprize\b/g, 'rent drop');
